import React from 'react';
import { UnitConverter } from './UnitConverter';

const units = [
  { key: 'hp',    label: 'H.P.' },
  { key: 'kw',    label: 'K.W.' },
  { key: 'mhp',   label: 'M.H.P.' },
  { key: 'watt',  label: 'Watt' },
  { key: 'jsec',  label: 'J / sec' },
  { key: 'kcal',  label: 'kcal' },
  { key: 'kwatt', label: 'kW' },
  { key: 'kgsec', label: 'kg·m / sec' },
];

// Base: H.P.
const factors = {
  hp:    1,
  kw:    0.7457,
  mhp:   1.01389,
  watt:  745.7,
  jsec:  745.70,
  kcal:  641.19,
  kwatt: 0.7457,
  kgsec: 76.07,
};

export const ConvPower = () => (
  <UnitConverter
    title="Power"
    units={units}
    factors={factors}
    explanationTitle="Units of power"
    explanation="1 H.P. = 0.7457 kW. The English system's horsepower is approximately 0.7457 times a kilowatt in the metric system."
  />
);
